import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import api from '../api/client';
import ParentQuestionnaireForm from '../components/ParentQuestionnaireForm';
import {
  EMPTY_PARENT_QUESTIONNAIRE,
  parentQuestionnaireFromApi,
} from '../questionnaire/parentOptions';

function formatFieldErrors(data) {
  if (!data || typeof data !== 'object') return 'Не удалось сохранить анкету';
  if (typeof data.detail === 'string') return data.detail;
  return Object.entries(data)
    .map(([key, val]) => `${key}: ${Array.isArray(val) ? val.join(', ') : val}`)
    .join('; ');
}

export default function ParentQuestionnairePage() {
  const { studentId } = useParams();
  const [searchParams] = useSearchParams();
  const fromInvite = searchParams.get('from') === 'invite';
  const navigate = useNavigate();

  const [form, setForm] = useState({ ...EMPTY_PARENT_QUESTIONNAIRE });
  const [studentName, setStudentName] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [previouslyFilled, setPreviouslyFilled] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError('');
      try {
        const res = await api.get(`/parent/children/${studentId}/questionnaire/`);
        if (cancelled) return;
        setForm(parentQuestionnaireFromApi(res.data));
        setPreviouslyFilled(Boolean(res.data?.filled));
        setStudentName(res.data?.student?.display_name || res.data?.student?.username || '');
      } catch (e) {
        if (!cancelled) {
          setError(e.response?.data?.detail || 'Не удалось загрузить анкету');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [studentId]);

  async function handleSubmit(e) {
    e.preventDefault();
    setSaving(true);
    setError('');
    setSuccess('');
    try {
      const res = await api.put(`/parent/children/${studentId}/questionnaire/`, form);
      setForm(parentQuestionnaireFromApi(res.data));
      setPreviouslyFilled(true);
      setSuccess('Анкета сохранена');
      if (fromInvite) {
        navigate('/parent');
      }
    } catch (err) {
      setError(formatFieldErrors(err.response?.data));
    } finally {
      setSaving(false);
    }
  }

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
        <p>Загрузка анкеты...</p>
      </div>
    );
  }

  return (
    <div className="questionnaire-page">
      <div className="page-header">
        <p>
          <Link to="/parent" className="back-link">← Кабинет родителя</Link>
        </p>
        <h1>Анкета родителя</h1>
        <p className="page-subtitle">
          Короткие вопросы, чтобы подобрать режим занятий. Можно изменить позже.
        </p>
      </div>

      <ParentQuestionnaireForm
        form={form}
        onChange={setForm}
        onSubmit={handleSubmit}
        saving={saving}
        error={error}
        success={success}
        studentName={studentName}
        submitLabel={previouslyFilled ? 'Сохранить изменения' : 'Отправить анкету'}
        extraActions={
          fromInvite ? (
            <button
              type="button"
              className="btn btn-outline"
              onClick={() => navigate('/parent')}
            >
              Заполнить позже
            </button>
          ) : null
        }
      />
    </div>
  );
}
